import React, { useState } from "react";
// import Button from "./Button";
import menuItems from "./MenuItems";
import logo from "../assets/images/logo/khuram.png"

import "./Navbar.css";
import { Button } from "react-bootstrap";

const Navbar = () => {
  const [active, setActive] = useState(false);
  const [colorChange, setColorchange] = useState(false);
  const changeNavbarColor = () =>{
     if(window.scrollY >= 80){
       setColorchange(true);
     }
     else{
       setColorchange(false);
     }
  };
  window.addEventListener('scroll', changeNavbarColor);

  const handleClick = () => {
    setActive(!active);
  };

  return (
    <nav className={colorChange ? 'navbar colorChange' : 'navbar'}>
      <div className="header">
      <div className="navbar-logo">
      <a href="index.html">
      <img src={logo} alt="logo" />
      </a>
      </div>
      </div>
      <div className="menu-icon" onClick={handleClick}>
        <i className={active ? "fas fa-times" : "fas fa-bars"}></i>
      </div>
      <ul className={active ? "nav-menu active" : "nav-menu"}>
        {menuItems.map((item, index) => {
          return (
            <li key={index}>
              <a href={item.url} className={item.cName}>
                {item.title}
              </a>
            </li>
          );
        })}
        {/* <Button className="btn">Buy Now</Button> */}
      </ul>
    </nav>
  );
};

export default Navbar;
